import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('userInitials', userInitials);

function userInitials() {
  return function (user, defaultValue) {
    const firstName = _.get(user, 'firstName');
    const lastName = _.get(user, 'lastName');

    if (!firstName || !lastName) {
      return defaultValue || 'NA';
    }
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  }
}
